import "@fontsource/source-sans-pro/400.css";
import "@fontsource/source-sans-pro/400-italic.css";
import "@fontsource/source-sans-pro/700.css";
import "@fontsource/source-sans-pro/700-italic.css";
import "@fontsource/dm-serif-display/400.css";
import "./src/styles/style.css";

// The resource blocker is loaded from the document head in gatsby-ssr.js so it
// runs before anything it needs to block. It only has to be re-run on
// client-side navigation, so the banner is not left stale.
//
// onRouteUpdate also fires for the initial page load, where the blocker has
// already initialized itself, so the first call is skipped and the re-run
// happens in onInitialClientRender instead.
let isFirstRoute = true;

export const onRouteUpdate = () => {
  if (isFirstRoute) {
    isFirstRoute = false;
    return;
  }

  if (window.Termly) {
    window.Termly.initialize();
  }
};

// The blocker's own startup pass does find the server-rendered iframes and
// builds its "Enable this content?" placeholders, but hydration then re-creates
// those subtrees and throws the placeholders away -- the iframes come back
// tagged data-termly-unknown-parent, which only elements created by script
// carry. Termly picks up iframes present at startup or added to the DOM on
// their own, never ones buried in a subtree React appended, so it does not
// notice them a second time. Develop never gets the placeholders at all: it
// serves an empty body, so there is nothing for the startup pass to find.
//
// Re-running the blocker once hydration has settled covers both.
export const onInitialClientRender = () => {
  if (window.Termly) {
    window.Termly.initialize();
  }
};
